import { create } from 'zustand'
import { ApprovalStatus } from '../database/enums/ApprovalStatus.enum'
import { LeaveRequest } from '../database/tables'

interface IAdminLeaveRequestApprovalPopupStore {
  open: boolean
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
  approvalStatus: ApprovalStatus | null
  data: LeaveRequest | null
}

const adminLeaveRequestApprovalPopupStore = create<IAdminLeaveRequestApprovalPopupStore>()(() => ({
  open: false,
  isLoading: false,
  isError: false,
  isSuccess: false,
  approvalStatus: null,
  data: null,
}))

export default adminLeaveRequestApprovalPopupStore
